import { selectSubscriptionProviderName } from '../../selectors/me';
import { providers } from './getSubscriptionProvider';

// temporary util to gate certain functionality until we migrate all zuora users to recurly.

export default function isZuoraSubscription(me) {
  return selectSubscriptionProviderName({ me }) === providers.zuora;
}
